import { render, staticRenderFns } from "./SDKPrivacyProtocol.vue?vue&type=template&id=1650871b&scoped=true"
import script from "./SDKPrivacyProtocol.vue?vue&type=script&lang=js"
export * from "./SDKPrivacyProtocol.vue?vue&type=script&lang=js"
import style0 from "./SDKPrivacyProtocol.vue?vue&type=style&index=0&id=1650871b&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1650871b",
  null
  
)

export default component.exports